import Link from 'next/link'
import styles from '../../styles/Applications.module.scss'
import techTalentStyles from '../../styles/TechTalent.module.scss'
import { Col, Row, Button, Image } from 'react-bootstrap'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { useRouter } from 'next/router'
import { isTechTalentEvent } from '../../helpers/url'

interface ViewProps {
	textView: string
}

const JobCard: FC<ViewProps> = (props): JSX.Element => {
	const { t } = useTranslation()
	const router = useRouter()
	const eventId = router.query.event as string
	const isTechTalent = eventId && isTechTalentEvent(eventId)

	return (
		<>
			<Row className='text-center justify-content-center'>
				<Col md={3}>
					<Image src='/img/no-jobs-applied.png' alt='no-jobs' className={styles.image} />
					<p className={styles.desc}><strong>{t(props.textView)}</strong></p>
					<div className='d-grid gap-2'>
						<Link href={eventId ? `/event/${eventId}` : '/browse-jobs'} passHref>
							<Button 
								variant={isTechTalent ? undefined : 'primary'} 
								className={`text-white mb-4 ${isTechTalent ? techTalentStyles.primaryBtn : ''}`}
							>
								{t('root.browse')}
							</Button>
						</Link>
					</div>
				</Col>
			</Row>
		</>
	)
}

export default JobCard